import { c as _c } from "react/compiler-runtime";
import { List, ListItem } from '@/comps/list';
import { cn } from '@/utils/shad';
import { FILTER_OPERATORS, FilterOperator, getOperatorLabel } from '@/comps/FilterPicker/filter-operators';
type Props = {
  selectedOperator: FilterOperator | null;
  onSelectOperator: (operator: FilterOperator) => void;
  allowedOperators?: FilterOperator[];
};
export function FilterContentV2OperatorDropdown(t0) {
  const $ = _c(9);
  const {
    selectedOperator,
    onSelectOperator,
    allowedOperators: t1
  } = t0;
  const allowedOperators = t1 === undefined ? FILTER_OPERATORS : t1;
  let t2;
  if ($[0] !== allowedOperators || $[1] !== onSelectOperator || $[2] !== selectedOperator) {
    let t3;
    if ($[4] !== onSelectOperator || $[5] !== selectedOperator) {
      t3 = operator => <ListItem key={operator} className={cn("flex cursor-pointer items-center rounded-[8px] p-2 transition-colors hover:bg-neutral-800", selectedOperator === operator && "bg-neutral-800")} onClick={() => onSelectOperator(operator)}><span className="text-xs text-foreground">{getOperatorLabel(operator)}</span></ListItem>;
      $[4] = onSelectOperator;
      $[5] = selectedOperator;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    t2 = allowedOperators.map(t3);
    $[0] = allowedOperators;
    $[1] = onSelectOperator;
    $[2] = selectedOperator;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[7] !== t2) {
    t3 = <div className="bg-[#09090B] p-1 shadow-md"><List className="z-50 flex w-auto flex-col gap-0.5">{t2}</List></div>;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
}